import { useEffect, useState } from 'react';
import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { api, ApiError, type Session } from '../api';
import { LoadingPanel, NotFound } from '../ui/bits';
import { Login } from './Login';
import { ReviewQueue } from './ReviewQueue';
import { Tenants } from './Tenants';
import { Admin } from './Admin';
import { Proposals } from './Proposals';
import { Intelligence } from './Intelligence';

export function OpsApp() {
  const [session, setSession] = useState<Session | null | undefined>(undefined);

  const load = () =>
    api
      .get<Session>('/api/auth/me')
      .then(setSession)
      .catch((err) => {
        if (err instanceof ApiError && err.status === 401) setSession(null);
        else console.error(err);
      });
  useEffect(() => {
    void load();
  }, []);

  if (session === undefined) return <LoadingPanel label="Loading your workspace…" />;
  if (session === null) return <Login onLogin={load} />;
  if (session.user.realm !== 'ops') {
    return (
      <div className="auth-card">
        <h1>Ops workspace</h1>
        <p className="muted">
          Signed in as {session.user.email} (client account). This workspace requires Plaidware staff
          access — clients use the <a href="/portal">client portal</a> instead.
        </p>
      </div>
    );
  }

  return (
    <div className="ops-shell">
      <nav className="ops-nav">
        <div className="ops-brand">MHub Ops</div>
        <div className="ops-nav-links">
          <NavLink to="/app/review">Review Queue</NavLink>
          <NavLink to="/app/tenants">Client 360</NavLink>
          <NavLink to="/app/proposals">Proposals</NavLink>
          <NavLink to="/app/intelligence">Intelligence</NavLink>
          <NavLink to="/app/admin">Admin</NavLink>
        </div>
        <div className="ops-user">
          <p className="muted tiny" style={{ margin: '0 0 8px', overflowWrap: 'anywhere' }}>
            {session.user.email}
          </p>
          <button type="button" className="btn-sm" onClick={() => api.post('/api/auth/logout').then(() => location.reload())}>
            Sign out
          </button>
        </div>
      </nav>
      <main className="ops-main">
        <Routes>
          <Route index element={<Navigate to="review" replace />} />
          <Route path="review" element={<ReviewQueue />} />
          <Route path="tenants/*" element={<Tenants />} />
          <Route path="proposals" element={<Proposals />} />
          <Route path="intelligence" element={<Intelligence />} />
          <Route path="admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}
